import { useEffect } from 'react'

const HEALTH_STORAGE_KEY = 'app_health_status'
const HEALTH_CHECKED_KEY = 'app_health_checked'

const HealthCheck = () => {
  useEffect(() => {
    const alreadyChecked = sessionStorage.getItem(HEALTH_CHECKED_KEY)

    if (alreadyChecked) {
      return
    }

    const checkHealth = async () => {
      try {
        const response = await fetch('/api/healthz')
        const data = await response.json()

        if (data.status === 'ok') {
          sessionStorage.setItem(HEALTH_STORAGE_KEY, 'healthy')
        } else {
          sessionStorage.setItem(HEALTH_STORAGE_KEY, 'unhealthy')
        }

        sessionStorage.setItem(HEALTH_CHECKED_KEY, 'true')
      } catch (error) {
        sessionStorage.setItem(HEALTH_STORAGE_KEY, 'error')
        sessionStorage.setItem(HEALTH_CHECKED_KEY, 'true')
      }
    }

    checkHealth()
  }, [])

  return null
}

export default HealthCheck
